import { render } from "./PopupBox.vue?vue&type=template&id=378afda4&scoped=true"
import script from "./PopupBox.vue?vue&type=script&lang=js"
export * from "./PopupBox.vue?vue&type=script&lang=js"

import "./PopupBox.vue?vue&type=style&index=0&id=378afda4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378afda4"]])

export default __exports__